//this takes the data obj as the obj and a path as a string with periods
//for example:
//data: {
//   setupLists: {
//     vehicleMakes: {
//       ...data here
//     }
//   }
// }
//obj = data
//path = 'setupLists.vehicleMakes'
//The path comes from the QUERY_LOOKUP dataPath.
//exported for testing

export function getValueFromPath(obj, path) {
  if(!obj || !path){
    return null;
  }

  try {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  } catch (err) {
    console.error(`There was an error getting value from path ${path}`, err);
    return null;
  }
}